<template>
  <div class="select-language">
    <div class="el-select-language">
      <div style="line-height: 16px;">
        <i
          class="el-icon-time"
          style="
            font-size: 16px;
            font-weight: bold;
            width: 20px;
            text-align: center;
            display:inline-block;
          "
          title="System time"
        ></i>
          <span class="timeWrap">{{timerSystem}}</span>
        <!-- {{ timeInfo.systemTime }} -->
        
      </div>
      <div v-if="timeInfo.storeTimeZone !== timeInfo.systemTimeZone" style="margin-top:3px;line-height: 16px;">
        <span style="width: 20px; text-align: center;display:inline-block;" title="Store time"
          ><feather-icon icon="HomeIcon" size="16" class="align-text-top"
        /></span>
        <span class="timeWrap">{{timerStore}}</span>
        <!-- {{ timeInfo.storeTime }} -->
        
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentTime } from "@/libs/api/language.js";
import moment from "moment";
import i18n from "@/libs/i18n/index";
export default {
  components: {},
  data() {
    return {
      timeInfo: {
        systemTimeZone: "",
        systemTime: "",
        storeTime: "",
        storeTimeZone: "",
      },
      timerSystem: '',
      timerStore: '',
      systemOffset: '-------- --:--:--',
      storeOffset: '-------- --:--:--',
      localeLanguage: JSON.parse(localStorage.getItem("localLanguage")),
      timer: null
    };
  },
  created() {
    // this.localLanguage = JSON.parse(localStorage.getItem('localLanguage'))
    this.getTime();
    
  },
  destroyed(){
    clearInterval()
    this.timer = null
  },
  methods: {
    // 格式化时间
    formatTime() {},
    // 获取时间信息
    getTime() {
      getCurrentTime().then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.timeInfo = {
            systemTimeZone: res.data.data.systemTimeZone,
            systemTime: res.data.data.systemTime,
            storeTime: res.data.data.storeTime,
            storeTimeZone: res.data.data.storeTimeZone,
          };
          const localStartTime = Date.now();
          this.systemOffset = (new Date(res.data.data.systemTime).getTime()) - localStartTime;
          this.storeOffset = this.timeInfo.storeTimeZone !== this.timeInfo.systemTimeZone ? (new Date(res.data.data.storeTime).getTime()) - localStartTime : '';

          this.timer = null
          this.timer = setInterval(() => {
            // 计算当前服务器时间
            const currentSystemTime = new Date().getTime() + this.systemOffset;
            this.timerSystem = moment(currentSystemTime).format('YYYY-MM-DD HH:mm:ss');
            if(this.timeInfo.storeTimeZone !== this.timeInfo.systemTimeZone){
              const currentStoreTime = new Date().getTime() + this.storeOffset;
              this.timerStore = moment(currentStoreTime).format('YYYY-MM-DD HH:mm:ss');
            }
          }, 100);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select-language {
  .el-select-language {
    width: 240px;
    margin-right: 5px;
    text-align: right;
    // line-height: 30px;
    font-size: 15px;
  }
  .timeWrap{
    color: #08b874;
    text-shadow: 0 0 3px rgba(0, 255, 157, 0.5);
    font-family: 'Courier New', monospace;
    font-weight:bold;
  }
  ::v-deep .el-input__suffix {
    display: none;
  }
  ::v-deep .el-input__inner {
    border: none;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
}
.language-img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
.li18 {
  height: 40px;
  display: flex;
  border-bottom: 1px solid #eeeeee;
}
.li18 div {
  line-height: 40px;
}
.li18 div img {
  width: 30px;
}
.li18 > span {
  display: block;
  padding-left: 4px;
  line-height: 40px;
}
</style>
